export default "__VITE_ASSET__Ccok5Xte__"